export default "__VITE_ASSET__C6d_pwvb__"